(function () {
  const CODE = "BUTTR10";
  const overlay = document.querySelector(".js-match-game");
  const grid = document.querySelector(".js-match-grid");
  const cards = Array.from(document.querySelectorAll(".js-match-card"));
  const win = document.querySelector(".js-match-win");
  const help = document.querySelector(".js-match-help");
  const bar = document.querySelector(".js-discount-bar");
  const toasts = document.querySelector(".js-toasts");
  const storageKey = "buttr_match_game";
  let selected = [];
  let locked = false;
  let gameWon = false;

  function claimed() {
    return localStorage.getItem(storageKey) === "claimed";
  }

  function showBar() {
    if (bar) bar.hidden = false;
    document.body.classList.add("has-discount");
  }

  function applyCode() {
    localStorage.setItem(storageKey, "claimed");
    showBar();
    window.location.href = "/discount/" + CODE + "?redirect=/";
  }

  function openGame() {
    if (!overlay || claimed()) return;
    overlay.hidden = false;
    document.body.classList.add("game-open");
  }

  function closeGame() {
    if (!overlay) return;
    overlay.hidden = true;
    document.body.classList.remove("game-open");
    if (!claimed()) localStorage.setItem(storageKey, "seen");
  }

  if (claimed()) showBar();
  else if (localStorage.getItem(storageKey) !== "seen") {
    window.setTimeout(openGame, 900);
  }

  if (grid && cards.length) {
    cards
      .sort(() => Math.random() - 0.5)
      .forEach((card) => grid.appendChild(card));
  }

  function resetSelection() {
    selected.forEach((card) => {
      card.classList.remove("is-revealed");
      card.setAttribute("aria-pressed", "false");
    });
    selected = [];
    locked = false;
  }

  function revealCard(card) {
    if (locked || gameWon || selected.includes(card)) return;
    card.classList.add("is-revealed");
    card.setAttribute("aria-pressed", "true");
    selected.push(card);

    if (selected.length !== 2) return;

    const [first, second] = selected;
    if (first.dataset.value === second.dataset.value) {
      gameWon = true;
      window.setTimeout(() => {
        if (win) win.hidden = false;
        if (help) help.hidden = true;
      }, 300);
      return;
    }

    locked = true;
    window.setTimeout(resetSelection, 750);
  }

  cards.forEach((card) => {
    card.addEventListener("click", () => revealCard(card));
  });

  document.querySelectorAll(".js-open-match-game").forEach((btn) => {
    btn.addEventListener("click", openGame);
  });
  document.querySelector(".js-match-close")?.addEventListener("click", closeGame);
  overlay?.addEventListener("click", (event) => {
    if (event.target === overlay) closeGame();
  });

  document.querySelector(".js-apply-code")?.addEventListener("click", applyCode);

  document.querySelectorAll(".offer-form").forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();
      const data = new FormData(form);
      fetch("/cart/add.js", {
        method: "POST",
        body: data,
        headers: { Accept: "application/json" },
      })
        .then(() => {
          window.location.href = "/discount/" + CODE + "?redirect=/cart";
        })
        .catch(() => form.submit());
    });
  });

  const proof = [
    "Melbourne just grabbed the 2-pack",
    "Sydney ordered a desk pack 3 min ago",
    "Someone in Brisbane added 1 Stick",
    "A 2-pack is heading to Perth",
    "Gold Coast just checked out",
  ];
  if (toasts) {
    let i = 0;
    window.setInterval(() => {
      const note = document.createElement("div");
      note.className = "toast";
      note.textContent = proof[i % proof.length];
      toasts.appendChild(note);
      i += 1;
      window.setTimeout(() => note.remove(), 4200);
    }, 14000);
    window.setTimeout(() => {
      const first = document.createElement("div");
      first.className = "toast";
      first.textContent = proof[0];
      toasts.appendChild(first);
      window.setTimeout(() => first.remove(), 4200);
    }, 5000);
  }

  document.addEventListener("mouseout", (event) => {
    if (event.clientY > 8 || claimed() || !overlay || overlay.hidden === false) return;
    if (localStorage.getItem(storageKey) === "seen") openGame();
  });
})();
